const camelToSnakeConverter = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
const snakeToCamelConverter = (str) =>
  str
    .split('_')
    .map((i, k) =>
      k
        ? i
            .split('')
            .map((i, k) => (k ? i.toLowerCase() : i.toUpperCase()))
            .join('')
        : i
    )
    .join('');

export function convertDataToDbView(data) {
  const convertedData = {};
  Object.keys(data).forEach((key) => {
    convertedData[camelToSnakeConverter(key)] = data[key];
  });

  return convertedData;
}

export function convertDataFromDbView(data) {
  const convertedData = {};
  Object.keys(data).forEach((key) => {
    convertedData[snakeToCamelConverter(key)] = data[key];
  });

  return convertedData;
}
